import Slider from "../modules/Slider.js";

new Slider();